import { getKeys } from './getKeys'

export const monitoringReportTranslations = {
  TO: 'To',
  FROM: 'From',
  FILTERS: 'Filters',
  LOGGED_BY: 'Logged by',
  FLUIDS_TITLE: 'Fluids Overview',
  FLUIDS_DESCRIPTION:
    'Total amount of fluids consumed per day in millilitres (ml)',
  TURNS_REPORT: 'Repositionings',
  TURNS_REPORT_DESCRIPTION: 'Total number of repositioning logs added per day',
  MEALS_REPORT: 'Food Report',
  MEALS_REPORT_DESCRIPTION: 'Total number of food portions consumed per day',
  BOWEL_MOVEMENT_REPORT: 'Bowel Movement Frequency',
  BOWEL_MOVEMENT_REPORT_DESCRIPTION:
    'Total number of bowel movement logs added per day',
  MOOD_REPORT: 'Mood Report',
  MOOD_REPORT_DESCRIPTION: 'Average mood score recorded per day',
  TEMPERATURE_REPORT: 'Temperature Report',
  TEMPERATURE_REPORT_DESCRIPTION:
    'Average body temperature recorded per day, in degree Celsius (°C)',
  ACTIVITY_SOCIAL_REPORT: 'Social activities',
  ACTIVITY_SOCIAL_REPORT_DESCRIPTION:
    'Total number of social activities logs added per day',
  STOOL_REPORT: 'Stool Report',
  STOOL_REPORT_DESCRIPTION: 'Stool Report Description',
  WASH_REPORT: 'Wash Report',
  WASH_REPORT_DESCRIPTION:
    'Total number of personal care routine and getting washed logs added per day',
  WEIGHT_REPORT: 'Weight Report',
  WEIGHT_REPORT_DESCRIPTION:
    'Average weight recorded per day in kilograms (kg)',
  ALL_LOGS_REPORT: 'Custom Logs Report',
  ALL_LOGS_REPORT_DESCRIPTION: 'Total number of logs created each day',

  // early access
  EARLY_ACCESS_TITLE: 'Early Access',
  EARLY_ACCESS_DESCRIPTION: 'Discover our new report and share your feedback',
  EARLY_ACCESS_BUTTON: 'Share your feedback',

  // popovers
  TOTAL_COUNT: 'Total Logs:',
  FLUIDS_POPOVER_TITLE: 'ml',
  FLUIDS_POPOVER_DESCRIPTION: 'Total fluids consumed on',
  MEALS_POPOVER_TITLE: 'portions',
  MEALS_POPOVER_DESCRIPTION: 'Portions of food consumed on',
  BOWEL_MOVEMENT_POPOVER_TITLE: 'bowel movements',
  BOWEL_MOVEMENT_POPOVER_DESCRIPTION: 'Total number of bowel movements on',
  TURNS_POPOVER_TITLE: 'repositionings',
  TURNS_POPOVER_DESCRIPTION: 'Total number of repositionings on',
  WEIGHT_POPOVER_TITLE: 'kg',
  WEIGHT_POPOVER_DESCRIPTION: 'Average weight recorded on',
  ALL_POPOVER_TITLE: 'logs',
  ALL_POPOVER_DESCRIPTION: 'Total logs on',
  TEMPERATURE_POPOVER_TITLE: 'degrees',
  TEMPERATURE_POPOVER_DESCRIPTION: 'Average temperature recorded on',
  SOCIAL_POPOVER_TITLE: 'social activities',
  SOCIAL_POPOVER_DESCRIPTION: 'Total number of social activities on',
  MOOD_POPOVER_TITLE: 'score',
  MOOD_POPOVER_DESCRIPTION: 'Average mood score on',
  STOOL_POPOVER_TITLE: 'logs',
  STOOL_POPOVER_DESCRIPTION: 'Total number of stool logs on',

  // preferences page
  PREFERENCES_TITLE: 'Monitoring Reports',
  PREFERENCES_SUBTITLE:
    'You can pick and choose which reports will appear under the Monitoring Reports in the Reports sections',
  FOOD_AND_FLUIDS_TITLE: 'Food and Fluids',
  HEALTH_RECORDINGS_TITLE: 'Health Recordings',
  PERSONAL_CARE_TITLE: 'Personal Care',
  SOCIAL_AND_ENVIRONMENT_TITLE: 'Social and Environment',
  CUSTOM_TITLE: 'Custom',

  // Food and Fluids Items
  FLUIDS_OPTION_LABEL: 'Fluids',
  FLUIDS_OPTION_DESCRIPTION: 'Overview of fluids consumed in millilitres  ',
  FOOD_OPTION_LABEL: 'Food',
  FOOD_OPTION_DESCRIPTION: 'Overview of food portions consumed in portions',

  // Health Recordings Items
  REPOSITIONINGS_LABEL: 'Repositionings',
  REPOSITIONINGS_DESCRIPTION: 'Overview of number of repositioning logs',
  BOWEL_LABEL: 'Bowel Movement',
  BOWEL_DESCRIPTION: 'Overview of number of bowel movement related logs',
  WEIGHT_LABEL: 'Weight',
  WEIGHT_DESCRIPTION: 'Overview of average weight logged each day',
  MOOD_LABEL: 'Mood',
  MOOD_DESCRIPTION: 'Overview of average mood score logged each day',

  // Personal Care Items
  WASH_LABEL: 'Wash',
  WASH_DESCRIPTION: 'Overview of number of temperature related logs',
  TEMPERATURE_LABEL: 'Temperature',
  TEMPERATURE_DESCRIPTION: 'Overview of number of temperature related logs',
  MENSTRUATION_LABEL: 'Menstruation',
  MENSTRUATION_DESCRIPTION: 'Overview of number of menstruation logs',

  // Social and Environment Items
  ENVIRONMENT_LABEL: 'Environment Checks',
  ENVIRONMENT_DESCRIPTION: 'Overview of number of environment check logs',
  SOCIAL_LABEL: 'Social Activities',
  SOCIAL_DESCRIPTION: 'Overview of number of social activities logs',

  // Custom Report Items
  CUSTOM_LABEL: 'Custom',
  CUSTOM_DESCRIPTION:
    'Overview of number of logs created for categories and items based on filters applied',

  // misc
  EXIT_WITHOUT_SAVING: 'Exit without saving',
  CANCEL: 'Cancel',
  SAVE_CHANGES: 'Save Changes',
  MODAL_TITLE: 'Changes not saved',
  MODAL_CONTENT:
    'You have made changes to Report Preferences. Leaving this page without saving will reset changes made.',
  EMPTY_STATE_TITLE: 'No data to show',
  EMPTY_STATE_DESCRIPTION:
    'There is no data to display. Try updating your filters.',
  TOAST: 'Monitoring Report menu successfully updated'
}

export const monitoringReportConstants = getKeys(monitoringReportTranslations)
